module.exports = __webpack_public_path__ + "img/sankoree.f060ec30.png";